import { Center, VStack, Box, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { MdCollections } from 'react-icons/md'

const NoMediaCollectionsView = ({minHeight}: {minHeight?: string}): ReactElement => {
  const { t } = useTranslation()

  return (
    <Center height="100%" width="100%" minHeight={minHeight}>
      <VStack spacing={8}>
        <Box background="appPaleGreyThree" padding={5} borderRadius="full">
          <Icon as={MdCollections} boxSize={20} color="appClearBlue" />
        </Box>
        <VStack spacing={2} width="100%">
          <Trans t={t} i18nKey="new_media_col">
            <Heading as="h4" fontSize="md" color="appBattleshipGrey">
              Use "New" button
            </Heading>
            <Heading
              as="h6"
              fontSize="sm"
              fontWeight="medium"
              color="appBattleshipGrey"
            >
              to create a media collection.
            </Heading>
          </Trans>
        </VStack>
      </VStack>
    </Center>
  )
}

export default NoMediaCollectionsView
